export interface BuildVersionFileUrlInput {
  /**
   * 后端服务根地址；调用方可以传入带尾部斜杠的地址。
   */
  readonly backendBaseUrl: string
  /**
   * 版本文件所属仓库 ID。
   */
  readonly repositoryId: string
  /**
   * 版本文件所属提交 ID。
   */
  readonly commitId: string
  /**
   * 文件在提交内的路径，必须整体编码后作为 path 参数传递。
   */
  readonly fileId: string
}

/**
 * 去除后端根地址尾部多余斜杠，保证下载路径拼接后稳定。
 *
 * @param backendBaseUrl 后端服务根地址。
 * @returns 去掉尾部斜杠后的后端根地址。
 */
function trimBackendBaseUrl(backendBaseUrl: string): string {
  const backend = backendBaseUrl.trim().replace(/\/+$/u, '')

  if (!backend) {
    throw new Error('backendBaseUrl is required')
  }

  return backend
}

/**
 * 生成后端版本文件下载地址。
 *
 * @param input 版本文件定位信息。
 * @returns 可供 fetch 读取的版本文件 URL。
 */
export function buildVersionFileUrl(input: BuildVersionFileUrlInput): string {
  const backend = trimBackendBaseUrl(input.backendBaseUrl)
  const repositoryId = encodeURIComponent(input.repositoryId)
  const commitId = encodeURIComponent(input.commitId)
  const path = encodeURIComponent(input.fileId)

  return `${backend}/download/version-file?repository_id=${repositoryId}&commit_id=${commitId}&path=${path}`
}
